import axios from 'axios';
import root from 'window-or-global';

const getUrl = (customEndpointUrl = '') => {
    let appContext = '';
    if (root.appContext && root.appContext !== '/') {
        ({appContext} = root);
    }

    const {location} = root;

    if (!location.origin) {
        const port = location.port ? `:${location.port}` : '';
        location.origin = `${location.protocol}//${location.hostname}${port}`;
    }
    const origin = location.origin + appContext;
    return `${origin}/${customEndpointUrl}`;
}

const submitCustomForm = async (formData, formId, customEndpointUrl) => {
    if (!formId) {
        throw new Error('MarketoCustomSource.submitCustomForm() requires a formId')
    }

    if (!customEndpointUrl) {
        throw new Error('MarketoCustomSource.submitCustomForm() requires a customEndpointUrl')
    }

    const api = getUrl(customEndpointUrl);

    let response = {};
    try {
        response = await axios.post(api, formData);
    } catch (e) {
        const error = e.response || {};
        console.error('MarketoCustomSource.submitCustomForm() failed to submit form', formId);
        return {errorMsg: error.data, status: error.status};
    }
    const data = response.data || {};
    return Object.assign(data, {status: response.status});
};

export const submitMwAppService = async (formData, formId) => {
    if (!formId) {
        throw new Error('MarketoCustomSource.submitMwAppService() requires a formId')
    }

    const request = {
        method: 'post',
        pathname: `/api/marketo/submit/${formId}`,
        body: formData
    };

    let response = {};
    try {
        response = await axios.post(`/api/app-service`, request, {
            withCredentials: true,
            headers: {
                'x-epic-include-account-token': true
            }
        });
    } catch (e) {
        const error = e.response || {};
        console.error('MarketoCustomSource.submitMwAppService() failed to submit form', formId);
        return {errorMsg: error.data, status: error.status};
    }
    const data = response.data || {};
    return Object.assign(data, {status: response.status});
};

export default submitCustomForm;
